<template>
    <div class="modal-backdrop" @mousedown="startDismiss" @mouseup="endDismiss" @keyup.esc="dismiss" ref="el">
        <div class="modal">
            <div class="modal-header">
                <slot name="header">
                    <h2 v-if="title">{{ title }}</h2>
                </slot>
                <div class="modal-dismiss" v-if="dismissable">
                    <a href="#" @click.prevent="dismiss"><i class="material-icons">clear</i></a>
                </div>
            </div>
            <section class="modal-body">
                <slot></slot>
            </section>
            <div class="modal-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
    autofocus: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: '',
    },
    dismissable: {
        type: Boolean,
        default: () => true,
    },
})

const emit = defineEmits(['dismiss'])

const el = ref(null)

watch(el, () => {
    if (el.value?.querySelector && props.autofocus) {
        el.value.querySelector('input')?.focus()
    }
})

let dismissing = false

function startDismiss(e) {
    if (el.value == e.target) {
        dismissing = true
    } else {
        dismissing = false
    }
}

function endDismiss(e) {
    if (el.value == e.target && dismissing) {
        dismiss()
    }
    dismissing = false
}

function dismiss() {
    if (props.dismissable) {
        emit('dismiss')
    }
}
</script>
<style scoped>
h2 {
    font-weight: 900;
    font-size: 24px;
    letter-spacing: 0.01px;
}
</style>
<style>
.modal-backdrop {
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    background-color: var(--color-modal-background);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-modal-backdrop);
}

.modal {
    background: #ffffff;
    box-shadow: var(--boxshadow-default);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: auto;
    padding: 24px;
    min-width: 480px;
    max-height: 100vh;
}

.modal-dismiss {
    color: #626166;
    flex-grow: 1;
    text-align: right;
}

.modal-header {
    align-items: center;
    display: flex;
    gap: 16px;
    justify-content: space-between;
}

.modal-body {
    height: 1%;
    flex-grow: 1;
    overflow-y: auto;
}

.modal-footer .button-group {
    margin: 0;
}

.modal-footer button {
    width: auto;
}

@media (max-width: 480px) {
    .modal {
        margin: 16px 0;
        padding: 24px;
        width: 100vw;
        max-height: calc(100dvh - 32px);
        min-width: 0;
        position: relative;
    }

    .modal-body {
        width: auto;
    }

    .modal-footer > button:first-child:last-child {
        text-align: center;
        width: 100%;
    }
}
</style>
